var Dropdown               = require("app/ui/Dropdown"),
    DropdownCaptureSupport = require("app/ui/DropdownCaptureSupport"),
    IconButton             = require("app/ui/IconButton"),
    TapCommandSupport      = require("app/ui/TapCommandSupport"),
    icons                  = require("app/theme/icons"),
    kind                   = require("enyo/kind");

require("./ZoomDropdown.less");
require("app/theme/IconButton--reader-toolbar.less");
require("app/theme/styles/popups/Popup--plain.less");

module.exports = kind(/** @lends  app.MediaPlayer.Tech.ImageReader.ZoomDropdown.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.ImageReader.ZoomDropdown",

    /**
     * @private
     */
    kind: Dropdown,

    /**
     * @private
     */
    mixins: [DropdownCaptureSupport],

    /**
     * @private
     */
    classes: "app-media-player-image-reader-zoom-dropdown",

    /**
     * @private
     */
    propagateCapturedTap: true,

    /**
     * The kind that will remain visible at all times and toggles the dropdown
     * when tapped.
     *
     * @type  {enyo.Control}
     * @public
     */
    activatorKind: IconButton,

    /**
     * Options for the activator.
     *
     * @type  {Object=}
     * @public
     */
    activatorOptions: {
        theme: "reader-toolbar",
        icon:  icons["app.MediaPlayer.ImageReader.ZoomDropdown.activator"]
    },

    /**
     * Options for the dropdown control
     *
     * @type  {Object=}
     * @public
     */
    dropdownOptions: {
        theme:           "plain",
        showCloseButton: false
    },

    /**
     * @private
     */
    components: [{
        name:       "zoomInButton",
        kind:       IconButton,
        classes:    "app-media-player-image-reader-zoom-dropdown__zoom-in-button",
        mixins:     [TapCommandSupport],
        icon:       icons["app.MediaPlayer.ImageReader.ZoomDropdown.zoomInButton"],
        theme:      "reader-toolbar",
        tapCommand: "onRequestZoomIn"
    }, {
        name:       "zoomOutButton",
        kind:       IconButton,
        classes:    "app-media-player-image-reader-zoom-dropdown__zoom-out-button",
        mixins:     [TapCommandSupport],
        icon:       icons["app.MediaPlayer.ImageReader.ZoomDropdown.zoomOutButton"],
        theme:      "reader-toolbar",
        tapCommand: "onRequestZoomOut"
    }],

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService    = this.app.$.i18nService;

        this.$.activator.set("tooltip", i18nService.getString("app.MediaPlayer.ImageReader.ZoomDropdown.Activator.tooltip"));
        this.$.zoomOutButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageReader.ZoomOutButton.tooltip"));
        this.$.zoomInButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageReader.ZoomInButton.tooltip"));
    }

});
